import React, { useState, useRef, useEffect } from "react";
import "./partner.scss";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import Sidebar from "../Sidebar/index";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { addPartnerAction, securityAction } from "../../actions/profileAction";
import { fetchGroupAction } from "../../actions/pgmAction";
import { securityQuesListAction } from "../../actions/securityActon";
import { NotificationManager } from "react-notifications";
import { safeEncode } from "../../common/encoder";
import Loader from "../../component/loaderComponent/Loader";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import moment from "moment/moment";
import { width } from "@mui/system";
import { pgmRolesAction } from "../../actions/pgmAction";
import Validation from "../../constants/validation/Validation";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import DOMPurify from "dompurify";
import Cookies from "js-cookie";
import { fileType } from "../../constants/filetype/filetype";
import { safeDecode } from "../../common/decoder";
import { hasPermission } from "../../utils/permissionUtils";
import {
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  MenuItem,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

const Partner = () => {
  const [activeButton, setActiveButton] = useState(1);
  const [states, setDataStates] = useState({
    name: "",
    DOB: "",
    email: "",
    password: "",
    cnfrmpassword: "",
    security_ques: "",
    answer: "",
    mobile_code: "91",
    mobile_number: "",
    profile: "",
    image_base64: "",
    imageName: "",
    roleid: [],
    discount_group_id: ""
  });
  const Country_name = safeDecode(Cookies.get('country_name'));
  const { loading, groupList } = useSelector((state) => state.getGroupReducer)
  const [securityquestionlist, Setsecurityquestionlist] = useState([]);
  const [Roles, setRoles] = useState([]);
  const To_date = states.DOB ? moment(states.DOB).format("YYYY-MM-DD") : "";
  const countryCode = localStorage.getItem('countryPhoneCode');
  const countryDomain = localStorage.getItem('countryCode');
  const countryPhoneLength = localStorage.getItem('countryPhoneLength')
  const countryMinPhoneLength = localStorage.getItem('countryMinPhoneLength')
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isPasswordVisibles, setPasswordVisibles] = useState(false);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");
  const handleChangeDropdown = (event) => {
    const selectedRoles = event.target.value;
    setDataStates({
      ...states,
      roleid: selectedRoles,
    });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [userid, setuserid] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let fileRef = useRef();

  useEffect(() => {
    security_quesListData();
    pgmrolesdata();
    handleChangeLanguage(language);
    dispatch(fetchGroupAction());
  }, []);

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handleImageChange = (evt) => {
    evt.preventDefault();
    var reader = new FileReader();
    var file = evt.target.files[0];
    if (file) {
      var profileImageSize = file.size / 1024 / 1024;
      const allowedImageTypes = fileType.IMAGE;
      if (profileImageSize < 5 && allowedImageTypes.includes(file.type)) {
        reader.onloadend = () => {
          setDataStates({
            ...states,
            image_base64: file,
            imageName: file.name,
          });
        };
        reader.readAsDataURL(file);
      } else {
        if (profileImageSize >= 5) {
          NotificationManager.error(t('addpartner.validationmb'));
        } else {
          NotificationManager.error(t('addpartner.invalidfiletype'));
        }
        if (fileRef.current) {
          fileRef.current.value = null;
        }
      }
    } else {
      NotificationManager.error(t('addpartner.pleaseselectimage'));
    }
  };

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setDataStates((prev) => ({ ...prev, [name]: value.replace(/^ +/gm, "") }));
  };

  const handleBlur = (evt) => {
    const { name, value } = evt.target;
    let newErrors = { ...errors };
    let newTouched = { ...touched, [name]: true };

    if (!value.trim()) {
      delete newErrors[name];
    } else {
      switch (name) {
        case "name":
          newErrors.name = Validation.textinputValidator(value) ? "" : "Invalid name format";
          break;
        case "email":
          newErrors.email = Validation.emailValidator(value) ? "" : "Invalid email format";
          break;
        default:
          break;
      }
    }

    setErrors(newErrors);
    setTouched(newTouched);
  };

  const PasswordRegex = /^[A-Za-z]*$/;

  async function security_quesListData() {
    setIsLoading(true);
    let response = await dispatch(securityQuesListAction());
    if (response == 200 || response != null) {
      Setsecurityquestionlist(response.data.results.data);
      setIsLoading(false);
    }
  }

  async function pgmrolesdata() {
    setIsLoading(true);
    let response = await dispatch(pgmRolesAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setRoles(response?.data?.data);
      setIsLoading(false);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  }
  const addnewpartner = async () => {
    var formData = new FormData();
    formData.append("name", states.name);
    formData.append("DOB", To_date);
    formData.append("email", states.email);
    formData.append("profile", states.image_base64);
    formData.append("mobile_code", countryCode);
    formData.append("mobile_number", phoneNumber);
    formData.append("discount_group_id", states.discount_group_id);
    { states.roleid.map((data) => formData.append("role_ids", data.id)); }
    setIsLoading(true);
    let response = await dispatch(addPartnerAction(formData));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setuserid(response.data?.data?.user);
      setsecurityques(response.data?.data?.user);
      window.scroll(0, 0);
    } else {
      setIsLoading(false);
    }
  }

  const handleGroupChange = (e) => {
    setDataStates((prevState) => ({
      ...prevState,
      discount_group_id: e.target.value,
    }));
  }

  const setsecurityques = async (id) => {
    if (states.password === states.cnfrmpassword) {
      try {
        let apiReq = {
          passcode: states.cnfrmpassword,
          security_ques: states.security_ques,
          answer: states.answer,
        };
        let response = await dispatch(securityAction(apiReq, id));
        if (response?.status === 200) {
          setIsLoading(false);
          navigate(`/businesspartners/${safeEncode(id)}`, { state: states.roleid });
          window.scroll(0, 0);
        } else {
          setIsLoading(false)
          NotificationManager.error(
            (t('validationmsg.failsecurityques')),
            response.data
          );
        }
      } catch (error) {
        NotificationManager.error((t('validationmsg.errorsecurityques')), error);
      }
    } else {
      setIsLoading(false);
      NotificationManager.error(t('addpartner.passwordError'));
    }
  };

  const routerEndPoint = process.env.REACT_APP_ROUTE_ENDPOINT || "";
  const formattedRouteEndpoint = routerEndPoint.replace(/\/+$/, "");

  const [button1Active, setButton1Active] = useState(false);
  const [button2Active, setButton2Active] = useState(false);
  const [draftButtonActive, setDraftButtonActive] = useState(false)
  const [button3Active, setButton3Active] = useState(false);

  const handlePendinButtonClick = (data) => {
    navigate(`/pgmlist`, { state: data });
    setButton1Active(!button1Active);
    setButton2Active(false);
    setDraftButtonActive(false);
    setButton3Active(false);
  };

  const handleApprovedButtonClick = (data) => {
    navigate(`/pgmlist`, { state: data });
    setButton1Active(false);
    setButton2Active(!button2Active);
    setDraftButtonActive(false);
    setButton3Active(false);
  };

  const handleDraftButtonClick = (data) => {
    navigate(`/pgmlist`, { state: data });
    setButton1Active(false);
    setButton2Active(false);
    setDraftButtonActive(!draftButtonActive)
    setButton3Active(false);
  };
  const handleAddpartnerButtonClick = () => {
    setButton1Active(false);
    setButton2Active(false);
    setDraftButtonActive(false)
    setButton3Active(!button3Active);
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  const togglePasswordVisibilitys = () => {
    setPasswordVisibles(!isPasswordVisibles);
  };

  const getMinDate = () => {
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 100);
    return minDate.toISOString().split('T')[0];
  };

  const getMaxDate = () => {
    const today = new Date();
    const subtractYears = parseInt(process.env.REACT_APP_DATE ? process.env.REACT_APP_DATE : 15);
    const maxDate = new Date(today.getFullYear() - subtractYears, today.getMonth(), today.getDate());
    const year = maxDate.getFullYear();
    let month = (maxDate.getMonth() + 1).toString().padStart(2, '0');
    let day = maxDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="details_containers_pgmpartner">
      <div className="partnerContainers">
        <div className="partnerContainer">
          <div className="partnerContainerright">
            <div className="header_border">
              <p className="pgm-list-header-text">TVS &gt; {t('questionnaire.addeditpgm')}</p>
            </div>
            <div className="pgmlist_buttons_container">
              <div className="pgmlist_buttons">
                {hasPermission(PERMISSIONS.CAN_VIEW_PGM_LIST) && (
                  <>
                    <button
                      className={
                        window.location.pathname === "/pgmlist" || button1Active
                          ? "activeAddnew"
                          : "pgmlist_Approved"
                      }
                      onClick={() => handlePendinButtonClick("pending")}
                    >
                      {t('pgmlist.buttons.pending')}
                    </button>
                    <button
                      className={
                        window.location.pathname === "/pgmlist" || button2Active
                          ? "activeAddnew"
                          : "pgmlist_Approved"
                      }
                      onClick={() => handleApprovedButtonClick("approved")}
                    >
                      {t('pgmlist.buttons.approved')}
                    </button>
                    <button
                      className={
                        window.location.pathname === "/pgmlist" || draftButtonActive
                          ? "activeAddnew"
                          : "pgmlist_Approved"
                      }
                      onClick={() => handleDraftButtonClick("draft")}
                    >
                      {t('pgmlist.buttons.draft')}
                    </button>
                  </>
                )}
                {hasPermission(PERMISSIONS.CAN_CREATE_PGM_USER) && (
                  <button
                    className={
                      window.location.pathname === `${formattedRouteEndpoint}/partner`
                        ? "activeAddnew"
                        : "pgmlist_Approved"
                    }
                    onClick={() => handleAddpartnerButtonClick("")}
                  >
                    {t('pgmlist.buttons.addNewPartner')}
                  </button>
                )}
              </div>
            </div>
            {isLoading ? (
              <Loader />
            ) : (
              <div>
                <div className="Partner_para_four">
                  <div className="Partner_para_fours">
                    <div className="Partner_para_fours_child">
                      <span className="Partner_para_four_span">1</span>
                      <p className="Partner_para_four_paragraph">{t('addpartner.profile')}</p>
                    </div>
                    <div className="Partner_para_fours_child">
                      <span className="Partner_para_four_spans">2</span>
                      <p className="Partner_para_four_paragraphs">
                        {t('addpartner.businessContactReferences')}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="personal_information">
                  <div class="personalino-container">
                    <div class="personalino-line"></div>
                    <div class="personalino-text">{t('addpartner.personalInfo')}</div>
                    <div class="personalino-line"></div>
                  </div>
                </div>
                <div className="personal_info_container">
                  <div className="personal_info_left">
                    <div className="img-container">
                      <img
                        src={
                          states.image_base64 === ""
                            ? Image_Url.PERSONALPROFILE
                            : DOMPurify.sanitize(URL.createObjectURL(states.image_base64))
                        }
                        width="100px"
                        onClick={() => fileRef.current.click()}
                        className="user-profile"
                        height={states.image_base64 !== "" && "100px"}
                        alt="img"
                        style={{
                          borderRadius:
                            states.image_base64 === "" ? "50%" : "50%",
                        }}
                      />
                      <div>
                        <img
                          src={Image_Url.PROFILEPLUS}
                          className="profile-plus-icons"
                          onClick={() => fileRef.current.click()}
                        />
                        <input
                          ref={fileRef}
                          onChange={handleImageChange}
                          multiple={false}
                          type="file"
                          accept="image/png,image/jpg, image/jpeg"
                          hidden
                        />
                      </div>

                      <br />
                    </div>
                  </div>
                  <div className="personal_info_right">
                    <div className="personal_inforight_inside">
                      <div className="loginthirdpara">
                        <div class="input-wrapper">
                          <label className="required" for="search">{t('addpartner.name')}</label>
                          <input
                            type="text"
                            placeholder={t('addpartner.namePlaceholder')}
                            name="name"
                            value={states.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {touched.name && errors.name && <span className="error-text">{errors.name}</span>}
                        </div>
                      </div>
                      <div className="loginthirdpara">
                        <div class="input-wrapper">
                          <label for="search">{t('addpartner.dateOfBirthLabel')}</label>
                          <input
                            id="dob"
                            type="date"
                            max={getMaxDate()}
                            min={getMinDate()}
                            placeholder="07-06-1993*"
                            name="DOB"
                            value={states.DOB}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="loginthirdpara">
                        <div class="input-wrapper">
                          <label className="phone_label required" for="search">
                            {t('addpartner.phoneNumberLabel')}
                          </label>
                          <div className="phone_input">
                            <PhoneInput
                              country={countryDomain}
                              value={countryCode}
                              inputProps={{
                                readOnly: true,
                              }}
                            />
                            <span className="phone_bar">|</span>
                            <input
                              className="number_inp"
                              maxLength={countryPhoneLength}
                              type="text"
                              value={phoneNumber}
                              onKeyPress={(e) => Validation.numberinputValidator(e)}
                              onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, ''))}
                              name="phoneNumber"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="personal_inforight_inside personal_inforight_inside_next">
                      <div className="loginthirdpara">
                        <div class="input-wrapper">
                          <label className="required" for="search">{t('addpartner.emailIdLabel')}</label>
                          <input
                            type="email"
                            placeholder={t('addpartner.emailPlaceholder')}
                            name="email"
                            value={states.email}
                            onChange={handleChange}
                            autoComplete="off"
                            onBlur={handleBlur}
                          />
                          {touched.email && errors.email && <span className="error-text">{errors.email}</span>}
                        </div>
                      </div>
                      <div className="loginthirdpara">
                        <div class="input-wrapper inp-wrapper">
                          <FormControl className="multiselect_partner">
                            <InputLabel className="required enroll_select" htmlFor="multiple-select">
                              {t('addpartner.enrollAsLabel')}
                            </InputLabel>
                            <Select
                              className="multiple_select"
                              labelId="multiple-select-label"
                              id="multiple-select"
                              multiple
                              value={states.roleid}
                              onChange={handleChangeDropdown}
                              inputProps={{ className: "multiselect_input" }}
                              renderValue={(selected) => {
                                const selectedRoleNames = selected.map(
                                  (data) => data.name
                                );
                                return selectedRoleNames.join(", ");
                              }}
                            >
                              {Roles?.map((item) => (
                                <MenuItem key={item.id} value={item}>
                                  <Checkbox
                                    checked={states.roleid.some(
                                      (role) => role.id === item.id
                                    )}
                                  />
                                  <ListItemText
                                    value={item.id}
                                    primary={item.name}
                                  />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="loginthirdpara">
                        {groupList?.length > 0 && (
                          <div class="input-wrapper">
                            <label for="search">{t('common.selectGroup')}</label>
                            <select className="select-group" onChange={handleGroupChange}>
                              <option value="">{t('common.default')}</option>
                              {groupList?.map((group) => (
                                <option key={group?.id} value={group?.id}>
                                  {group?.group_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="personal_information">
                  <div class="security-container">
                    <div class="security-line"></div>
                    <div class="security-text">{t('addpartner.securityDetail')}</div>
                    <div class="security-line"></div>
                  </div>
                </div>
                <div className="partners_five_para">
                  <div className="personal_inforight_security">
                    <div className="pass-flex">
                      <div className="loginthirdpara-security">
                        <div class="input-wrapper">
                          <label className="required" for="search">{t('addpartner.passwordLabel')}</label>
                          <input
                            className="security-input-select"
                            type={isPasswordVisible ? "text" : "password"}
                            placeholder={t('addpartner.passwordPlaceholder')}
                            name="password"
                            value={states.password}
                            onChange={handleChange}
                            autoComplete="new-password"
                            maxLength={24}
                            minLength={8}
                          />
                          <span
                            className={`pass-icon ${isPasswordVisible ? "visible" : ""
                              }`}
                            onClick={togglePasswordVisibility}
                          >
                            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                          </span>
                          {
                            states.password.length > 0 && ((states.password.length < 8) ||
                              (states.password.length > 24) ||
                              (PasswordRegex.test(states.password)))
                              ? <div id="message">
                                {t('addpartner.passwordHint')}
                              </div>
                              : ""}
                        </div>
                      </div>
                      <div className="loginthirdpara-security">
                        <div class="input-wrapper">
                          <label className="required" for="search">{t('addpartner.confirmPasswordLabel')}</label>
                          <input
                            className="security-input-select"
                            type={isPasswordVisibles ? "text" : "password"}
                            placeholder={t('addpartner.confirmPasswordPlaceholder')}
                            name="cnfrmpassword"
                            value={states.cnfrmpassword}
                            onChange={handleChange}
                            autoComplete="new-password"
                            maxLength={24}
                            minLength={8}
                          />
                          <span
                            className={`pass-icon ${isPasswordVisibles ? "visible" : ""
                              }`}
                            onClick={togglePasswordVisibilitys}
                          >
                            {isPasswordVisibles ? <FaEyeSlash /> : <FaEye />}
                          </span>
                          {
                            states.cnfrmpassword.length > 0 && (states.cnfrmpassword !== states.password)
                              ? <div id="message">
                                <span>{t('addpartner.passwordError')}</span>
                              </div>
                              : ""}
                        </div>
                      </div>
                    </div>
                    <div className="pass-flex">
                      <div className="loginthirdpara-security">
                        <div class="input-wrapper inp-wrapper">
                          <label className="required" for="first">{t('addpartner.securityQuestionLabel')}</label>
                          <select
                            className="security-input-select"
                            name="security_ques"
                            value={states.security_ques}
                            onChange={handleChange}
                          >
                            <option value="">{t('addpartner.sleectsecurityQuestion')}</option>
                            {securityquestionlist.map((data) => (
                              <option value={data.id}>
                                {data.security_question}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="loginthirdpara-security">
                        <div class="input-wrapper-addpartner-answers">
                          <label className="required" for="search">{t('addpartner.answerLabel')}</label>
                          <input
                            className="security-input-select"
                            type="text"
                            placeholder={t('addpartner.enteranswer')}
                            name="answer"
                            value={states.answer}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Securityquestion_text">
                  {t('addpartner.securityHint')}
                </div>
                <div className="Button_nexts">
                  <button
                    className="button_nextPartner"
                    onClick={addnewpartner}
                    disabled={
                      !states.email ||
                      !states.roleid ||
                      !states.name ||
                      !states.password ||
                      !states.security_ques ||
                      !states.cnfrmpassword ||
                      !states.answer ||
                      states.roleid.length === 0 ||
                      states.password.length < 8 ||
                      states.password.length > 24 ||
                      PasswordRegex.test(states.password) ||
                      states.cnfrmpassword !== states.password ||
                      !phoneNumber || phoneNumber.length < countryMinPhoneLength
                    }
                  >
                    {t('addpartner.nextButton')}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partner;
